class DocumentariesTemplate {
	constructor() {
		this.filterValues = {
			topic: '',
			showing: '',
			page: 1
		};

		this.searchValue = {
			search: '',
			page: 1,
			active: false
		};

		this.init();
		this.setEventHandlers();
	}

	showSpinner = () => {
		const spinner = document.querySelector('.ui__spin-loader');
		const documentariesRow = document.querySelector('.tmpl-documentaries__row');
		if (spinner) {
			spinner.style.display = 'block';
			documentariesRow.style.display = 'none';
		}
	};

	hideSpinner = () => {
		const spinner = document.querySelector('.ui__spin-loader');
		const documentariesRow = document.querySelector('.tmpl-documentaries__row');

		if (spinner) {
			spinner.style.display = 'none';
			documentariesRow.style.display = 'flex';
		}
	};

	init = async () => {
		const queryParams = new URLSearchParams(window.location.search);
		const topic = queryParams.get('topic');
		const showing = queryParams.get('showing');
		const search = queryParams.get('search');
		const page = queryParams.get('currentpage');
		if (topic) this.filterValues.topic = topic;
		if (showing) this.filterValues.showing = showing;
		if (page) this.filterValues.page = page;
		if (search) {
			this.searchValue.search = search;
			this.searchValue.active = true;
		}

		this.updateFilterValues(this.filterValues);

		let data = await this.fetchDocumentaries(this.filterValues);

		if (search) {
			this.updateSearchValue(search);
			data = await this.fetchDocumentaries({ search: search, page: page });
		}

		this.updateContent(data);
	};

	fetchDocumentaries = async (params = {}) => {
		this.showSpinner();

		// Combine all filter parameters
		const combinedParams = { ...this.filterValues, ...params };

		const { topic, showing, page, search } = combinedParams;

		let endpoint = '/wp-json/wp/v2/film-meta';
		const queryParams = [];

		if (topic) queryParams.push(`topic=${topic}`);
		if (showing && showing !== 'all') queryParams.push(`showing=${showing}`);
		if (page) queryParams.push(`currentpage=${page}`);
		if (search && search.length > 0) queryParams.push(`search=${search}`);

		let baseUrl;

		if (window.location.pathname.includes('independentlens')) {
			endpoint = '/independentlens/wp-json/wp/v2/film-meta';
			baseUrl = `${window.location.origin}/independentlens/our-documentaries/`;
		} else {
			baseUrl = `${window.location.origin}/our-documentaries/`;
		}

		if (queryParams.length > 0) {
			endpoint += '?' + queryParams.join('&');
			const newUrl = `${baseUrl}?${queryParams.join('&')}`;
			history.pushState(null, '', newUrl);
		}

		const data = await fetch(endpoint)
			.then((response) => response.json())
			.then((res) => {
				const documentaries = res.films;
				const { pagination } = res;
				this.hideSpinner();
				return { documentaries, pagination };
			})
			.catch((error) => console.error('Error:', error));

		return data;
	};


	setEventHandlers = () => {
		this.handleFiltrationChange();
		this.handleToggleFilters();
	};

	handleToggleFilters = () => {
		const toggleButton = document.querySelector('#toggle-filters-button');
		const filters = document.querySelector('.tmpl-documentaries__filtration');

		if (toggleButton && filters) {
			toggleButton.addEventListener('click', () => {
				const isShown = filters.classList.contains('show');
				if (isShown) {
					filters.classList.remove('show');
					toggleButton.textContent = 'Show Filters +';
					// Delay hiding the display to allow transition
					setTimeout(() => {
						filters.style.display = 'none';
					}, 300); // Match the duration of the CSS transition
				} else {
					filters.style.display = 'block';
					setTimeout(() => filters.classList.add('show'), 0); // Add show class after enabling display
					toggleButton.textContent = 'Hide Filters -';
				}
			});
		}
	};



	handleFiltrationChange = () => {
		// Topic select
		const topicSelect = document.querySelector('.tmpl-documentaries__topic-select');
		topicSelect.addEventListener('change', async (e) => {
			e.preventDefault();

			// Update topic in filter values
			const selectedTopic = e.target.value;
			this.filterValues.topic = selectedTopic;
			this.filterValues.page = 1;

			// Include the search value (if any) in the API query
			const data = await this.fetchDocumentaries({
				...this.filterValues,
				search: this.searchValue.search, // Include current search value
			});

			this.updateContent(data);
		});


		// Showing filter
		const showingRadio = document.querySelector('.tmpl-documentaries__showing-filter-radio');
		showingRadio.addEventListener('change', async (e) => {
			e.preventDefault();
			const selectedShowing = e.target.value;
			this.filterValues.showing = selectedShowing;
			this.filterValues.page = 1;

			this.updateSearchValue('');
			const filteredDocumentaries = await this.fetchDocumentaries(this.filterValues);

			this.updateContent(filteredDocumentaries);
		});

		// Pagination buttons
		document.addEventListener('click', async (e) => {
			if (e.target.closest('.pagination__item--page button')) {
				e.preventDefault();
				const page = parseInt(e.target.dataset.page, 10);
				let data;

				if (this.searchValue.active) {
					this.searchValue.page = page;
					data = await this.fetchDocumentaries({
						search: this.searchValue.search,
						page: page
					});
				} else {
					this.filterValues.page = page;
					data = await this.fetchDocumentaries(this.filterValues);
				}

				this.updateContent(data);
			}

			const buttons = ['next', 'prev'];

			buttons.forEach(async (button) => {
				if (e.target.closest(`.pagination__item--${button} button`)) {
					e.preventDefault();
					let currentPage = parseInt(this.filterValues.page, 10);
					if (button === 'next') {
						currentPage += 1;
					} else {
						currentPage -= 1;
					}
					this.filterValues.page = currentPage;

					const data = await this.fetchDocumentaries(this.filterValues);
					this.updateContent(data);
				}
			});
		});

		// Search
		const searchSubmit = document.querySelector('.tmpl-documentaries__search-submit');
		const searchInput = document.querySelector('.tmpl-documentaries__search-input');

		searchSubmit.addEventListener('click', async (e) => {
			e.preventDefault();
			const searchValue = searchInput.value;

			this.searchValue.search = searchValue;
			this.searchValue.active = true;

			const data = await this.fetchDocumentaries({
				...this.filterValues,
				search: searchValue,
				page: 1,
			});

			this.updateContent(data);
		});


		// Reset filters
		const resetFiltersButton = document.querySelector(
			'.tmpl-documentaries__reset-filters-button'
		);

		resetFiltersButton.addEventListener('click', async (e) => {
			e.preventDefault();

			this.filterValues = { topic: '', showing: '', page: 1 };
			this.searchValue = { search: '', page: 1, active: false };

			topicSelect.value = '';
			searchInput.value = '';

			const showingRadios = document.getElementsByName('filter');
			showingRadios.forEach((radio) => {
				if (radio.value === 'all') radio.checked = true;
			});

			const data = await this.fetchDocumentaries(this.filterValues);
			this.updateContent(data);
		});


	};

	updateContent = (data) => {
		const documentariesRow = document.querySelector('.tmpl-documentaries__row');
		const { documentaries } = data;

		documentariesRow.innerHTML = '';
		if (documentaries.length === 0) {
			documentariesRow.innerHTML =
				' <div class="columns small-12"> <h4>No results found</h4> </div> ';
		}
		documentaries.forEach((documentary) => {
			const cardMarkup = documentary.card_markup;
			documentariesRow.innerHTML +=
				'<div class="columns small-12 medium-6 large-4">' + cardMarkup + '</div>';
		});
		this.displayPagination(data.pagination);
	};

	updateFilterValues = (filterValues) => {
		const topicSelect = document.querySelector('.tmpl-documentaries__topic-select');
		const showingRadios = document.getElementsByName('filter');

		if (filterValues.topic) {
			topicSelect.value = filterValues.topic;
		}

		if (filterValues.showing) {
			showingRadios.forEach((radio) => {
				if (radio.value === filterValues.showing) {
					radio.checked = true;
				}
			});
		}
	};

	updateSearchValue = (searchValue) => {
		const searchInput = document.querySelector('.tmpl-documentaries__search-input');
		searchInput.value = searchValue;
	};

	displayPagination = async (pagination) => {
		const paginationContainer = document.querySelector('.pagination');
		paginationContainer.innerHTML = '';
		const totalPages = pagination.total_pages;
		const currentPage = pagination.current_page;

		let paginationMarkup = '';

		if (totalPages > 1) {
			if (currentPage !== 1) {
				paginationMarkup += `
					<li class="pagination__item pagination__item--prev">
						<button type="button">Previous</button>
					</li>
				`;
			}

			let startPage = Math.max(1, currentPage - 2);
			let endPage = Math.min(totalPages, currentPage + 2);

			if (currentPage > 5) {
				startPage = currentPage - 2;
				endPage = currentPage + 2;
			}

			// Display first few pages or pages near the current page
			if (currentPage > 5) {
				paginationMarkup += `
					<li class="pagination__item pagination__item--page">
						<button type="button" aria-label="Page ${1}" ${currentPage === 1 ? 'aria-current="true"' : ''}
							data-page="$1" class="${currentPage === 1 ? 'active' : ''}">${1}</button>
					</li>
				`;

				paginationMarkup += `<li class="pagination__item pagination__item--ellipsis"><span>...</span></li>`;
			}

			for (let i = startPage; i <= endPage; i++) {
				if (i >= 1 && i <= totalPages) {
					paginationMarkup += `
						<li class="pagination__item pagination__item--page">
							<button type="button" aria-label="Page ${i}" ${i === currentPage ? 'aria-current="true"' : ''}
								data-page="${i}" class="${i === currentPage ? 'active' : ''}">${i}</button>
						</li>
					`;
				}
			}

			// If endPage is less than totalPages, add ellipsis and last page
			if (endPage < totalPages - 1) {
				paginationMarkup += `<li class="pagination__item pagination__item--ellipsis"><span>...</span></li>`;
			}

			if (totalPages > 5 && endPage < totalPages) {
				paginationMarkup += `
					<li class="pagination__item pagination__item--page">
						<button type="button" aria-label="Page ${totalPages}" 
							${totalPages === currentPage ? 'aria-current="true"' : ''}
							data-page="${totalPages}" 
							class="${totalPages === currentPage ? 'active' : ''}">${totalPages}</button>
					</li>
				`;
			}

			if (currentPage !== totalPages) {
				paginationMarkup += `
					<li class="pagination__item pagination__item--next">
						<button type="button">Next</button>
					</li>
				`;
			}

			paginationContainer.innerHTML = paginationMarkup;
		}
	};
}

export default DocumentariesTemplate;
